export default __webpack_public_path__ + "images/msaserversigninlottie_2_971cad321ff003001b8bef05e073f100.json";